// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import Alpine from "alpinejs"
import collapse from '@alpinejs/collapse'
import 'tom-select'
import './controllers'
import './alpine'

Alpine.plugin(collapse)
window.Alpine = Alpine

Alpine.start()